import { lazy, Suspense } from 'react';

// marked + DOMPurify load with the first rendered Markdown, not with the main chunk.
const Markdown = lazy(() => import('./Markdown').then((m) => ({ default: m.Markdown })));

/** `Markdown`, code-split. Shows the raw text until the renderer has loaded (a moment, once per session). */
export function LazyMarkdown({ content, className }: { content: string; className?: string }) {
  return (
    <Suspense fallback={<div className={className}><p className="whitespace-pre-wrap">{content}</p></div>}>
      <Markdown content={content} className={className} />
    </Suspense>
  );
}
